import jquery from "jquery";

export default (window.$ = window.jquery = jquery);
